export default __webpack_public_path__ + "static/media/pricing.a5c44618.svg";